var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1ff92249dcc520705149df459b3b86a1e5d06184"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["project-template-web@codeleap"]={id:"1ff92249dcc520705149df459b3b86a1e5d06184"};
      